import React, { useEffect } from "react";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { BarChart, Globe, Heart, Users } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
export default function ImpactPage() {

const navigate = useNavigate(); // Initialize navigate
const location = useLocation();


  const handleClick = () => {
    navigate("/registration#internship-section"); // This will navigate to the "/another-page" route
  };

    const handleClick_2 = () => {      
       window.open("https://docs.google.com/forms/d/1iwEzu53wDAe41RjEDe-gHIX9H61QikSfR2RKmyCBp_M/edit");  // This will navigate to the "/another-page" route
    };
    const handleClick_3 = () => {
    window.open("https://docs.google.com/forms/d/1Q2Lc15IwomBIFeSAxIfsK56xI3vkCjvKW8yXQcWQvmM/edit"); // This will navigate to the "/another-page" route
    };

 useEffect(() => {
      if (location.hash) {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }
    }, [location]);

  const headlineStats = [
    { label: 'Youth trained', value: '100+' , icon: Users},
    { label: 'Seniors served', value: '50+' , icon: Heart},
    { label: 'Counties & Cities', value: '4 counties · 8 cities', icon: Globe},
    { label: 'Ambassador Initiatives', value: '10 launched', icon: BarChart},
  ]

  const surveyStats = [
    { stat: '92%', caption: 'Interns reported improved confidence & leadership skills' },
    { stat: '9/10', caption: 'Participants said the program changed how they think about their future in tech' },
    { stat: '100%', caption: 'Interns improved teamwork & problem-solving abilities' },
    { stat: '80%+', caption: 'Built portfolios or pursued internships/jobs after the program' },
  ]

  const byTheNumbers = [
    { label: 'Interns (Summer 2025)', value: '12' },
    { label: 'Collaborative apps built', value: '10' },
    { label: 'Rated Excellent/Good', value: '85%' },
    { label: 'Would recommend', value: '100%' },
  ]

  const voices = [
    { name: 'Zarya', quote: 'This internship made me consider how to develop applications more ethically so they could have more widespread use in communities.' },
    { name: 'Liyah', quote: 'I loved building the websites and apps. It allowed me to find my passion in web design again.' },
    { name: 'Shogufta', quote: 'At first GitHub was confusing, but now I can push, pull, and commit with confidence.' },
    { name: 'Kavi', quote: 'I have been an intern for Choicest Fruit for 2 years and I have learned a lot about the rapid development of technology and how to use it. I have gained skills in basic website development including understanding html, css and javascript. ' },
  ]

  return (
    <div
      className="min-h-screen text-slate-900"
      style={{ paddingTop: "5.5rem", backgroundColor: " #4F97A3" }} // Set page background here
    >
      <header className="max-w-6xl mx-auto p-6 sm:p-10">
        <div className="flex items-center justify-between">
          <h1 className="text-3xl sm:text-4xl font-extrabold">Our Impact</h1>
                  </div>
     <p className="mt-4 max-w-3xl text-slate-900 text-[22px]">
          Since 2024 we’ve centered our work in the City of Austin and across Hays and Travis Counties,
          Texas, closing equity gaps in tech education by equipping youth with hands-on coding, robotics, organic urban gardening and ethical
          technology training, plus mentorship and pathways from Learners → Ambassadors → Innovators → Entrepreneurs.
            Our programs also serve seniors, schools, and tech companies, ensuring technology benefits all.
        </p>
      </header>

      <main className="max-w-6xl mx-auto p-6 sm:p-10 space-y-12">
        {/* Headline Stats */}
        <section className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-white shadow rounded-lg p-8">
            <h2 className="text-2xl font-bold">Headline Impact</h2>
            <p className="mt-2 text-slate-600">Representation gaps persist in tech, we work locally and internationally to change that by focusing on hands-on learning, mentorship, and real-world projects.</p>

            <div className="mt-6 grid grid-cols-2 gap-4">
              {headlineStats.map((h) => (
                <div key={h.label} className="flex items-start gap-4 p-4 bg-slate-50 rounded-md">
                  <div className="p-2 rounded-md bg-white shadow-sm">
                    {h.icon && React.createElement(h.icon, { size: 32, className: "mb-2 text-sky-700" })}
                    <h3 className="text-xl font-bold">{h.value}</h3>
                    <p className="text-sm text-slate-600">{h.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Survey Stats */}
          <div className="bg-white shadow rounded-lg p-8">
            <h2 className="text-2xl font-bold">Survey Highlights</h2>
            <p className="mt-2 text-slate-600">Participant surveys showing measurable growth.</p>

            <div className="mt-6 grid grid-cols-2 gap-4">
              {surveyStats.map((s) => (
                <Card key={s.stat}>
                  <Card.Body>
                    <div>
                      <div className="text-3xl font-extrabold">{s.stat}</div>
                      <div className="mt-1 text-sm text-slate-600">{s.caption}</div>
                    </div>
                  </Card.Body>
                </Card>
              ))}
            </div>
          </div>
        </section>

        {/* Participant Voices */}
        <section className="bg-white shadow rounded-lg p-8">
          <h2 className="text-2xl font-bold">Participant Voices</h2>
          <p className="mt-2 text-slate-600">Reflections from interns and participants </p>

          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {voices.map((v) => (
              <blockquote key={v.name} className="p-4 border-l-4 border-sky-500 bg-slate-50 rounded">
                <p className="italic">“{v.quote}”</p>
                <footer className="mt-3 text-sm font-medium">— {v.name}</footer>
              </blockquote>
            ))}
          </div>
        </section>

        {/* Visual Impact / By the Numbers */}
        <section className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
          <div className="lg:col-span-2 bg-white shadow rounded-lg p-8">
            <h2 className="text-2xl font-bold">By the Numbers (Summer 2025 Internship)</h2>
            <p className="mt-2 text-slate-600">A snapshot of our recent cohort showing program outputs and participant outcomes.</p>

            <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-4">
              {byTheNumbers.map((b) => (
                <div key={b.label} className="p-4 bg-slate-50 rounded-md text-center">
                  <div className="text-2xl font-extrabold">{b.value}</div>
                  <div className="mt-1 text-sm text-slate-600">{b.label}</div>
                </div>
              ))}
            </div>

            <div className="mt-8">
              <h3 className="font-bold">Intern Projects</h3>
              <p className="text-slate-600 mt-2">Interns built collaborative apps including Crop Companion Finder, Breathing & Meditation App and utility tools focused on local problems. Projects emphasized design, accessibility, and ethical technology.</p>

              <div className="mt-4 flex gap-3 flex-wrap">
                
                <Button onClick={handleClick}>Apply for Internship</Button>
              </div>
            </div>
          </div>

          {/* Small partners / reach card */}
          <aside className="bg-white shadow rounded-lg p-6">
            <h3 className="text-lg font-bold">Our Reach So Far</h3>
            <ul className="mt-4 text-slate-600 space-y-3">
              <li>100+ youth trained in coding, robotics, and ethical tech</li>
              <li>50+ seniors served in digital literacy</li>
              <li>4 counties & 8 cities impacted</li>
              <li>10 youth-led initiatives launched</li>
              <li>Partnerships in US, South Africa & Uganda </li>
            </ul>
          </aside>
        </section>

        {/* Call to action + Partners */}
        <section className="bg-white shadow rounded-lg p-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-2xl font-bold">Partner with us</h3>
            <p className="mt-2 text-slate-600">Support programs, mentorship, or offer project opportunities, help us scale local impact and diversify tech pathways.</p>
          </div>
          <div className="flex gap-3">
            <Button onClick={handleClick_2}>Become a Partner</Button>
            <Button onClick={handleClick_3}>Volunteer / Mentor</Button>
          </div>
        </section>

        <footer className="text-center text-sm text-slate-900 py-8">
          <div>Raising awareness on ethical & responsible technology through our YouTube channel and online content.</div>
          {/* <div className="mt-2">© {new Date().getFullYear()} Choicest Fruit®</div> */}
        </footer>
      </main>
    </div>
  )
}
